module.exports = __webpack_public_path__ + "img/crt.11629136.png";